export const ENumerologyType = {
    NAME: 'name',
    LOVE: 'love',
    BUSINESS: 'business'
} as const;

export type TNumerologyType = (typeof ENumerologyType)[keyof typeof ENumerologyType];

const NUMEROLOGY_TYPES: readonly string[] = Object.values(ENumerologyType);

export const isNumerologyType = (value?: string): value is TNumerologyType =>
    !!value && NUMEROLOGY_TYPES.includes(value);

export const MIN_LOADING_DURATION_MS = 1800;

export const MIN_NAME_LENGTH = 3;

export const AUTH_REDIRECT_COOKIE = 'auth_redirect_to';

export const AUTH_REDIRECT_META = 'auth-redirect-route';

export const CLOSE_STYLED_MODAL_EVENT = 'CloseStyledModal';
